<template>
  <div class="activity__items">
    <!--
    similar: src/components/ProductsCarousel.vue:43
    e.g. <client-activity-container> => <client-activity> => <products-carousel>
    -->
    <template v-for="(item, index) in items">
      <product
        :key="'activity' + index"
        :name="getProductName(item)"
        :price="item.formatted_price"
        :size="item.size_info"
        :thumbnail="item.thumb"
        thumbnail-size="medium"
        :url="item.site_url"

        :date-verb="dateVerb"
        :last-update="item.date || lastUpdate"
        :show-size="showSize"
        :placeholder="item.placeholder"
        :is-like="item.isActivityLike || item.is_video_appointment_like"
        :liked-location="formatLikeLocationLabel(item)"
      />
    </template>
  </div>
</template>

<script>
import utilsMixin from '@/_utilities/utilsMixin';

export default {
  name: 'ActivityItems',
  mixins: [utilsMixin],
  props: {
    showSize: {
      type: Boolean,
      default: true,
    },
    name: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
    lastUpdate: {
      type: String,
      default: '',
    },
    dateVerb: {
      type: String,
      default: 'Added',
    },
  },
};
</script>

<style lang="scss" scoped>
.activity__items{
  display: grid;
  column-gap: 8px;
  grid-template-columns: repeat(auto-fit, 120px);
}
.activity__img {
  margin: 0.3rem 0;
  display: inline-block;
}
.activity__tooltip {
  text-align: center;

  hr {
    margin: 0.2rem 0;
    border-color: rgba(white, 0.2);
  }
}
</style>
